import React, { useEffect, useState } from "react";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import Table from "../shared/table/Table";
import { fetchFormData, formatDateOnly, getValueLabel } from "../../utils/options";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { leadPriorityData } from "../../utils/options";
import { FiEdit3, FiRefreshCcw, FiSliders } from "react-icons/fi";
import FollowUpModal from "../../utils/FollowUpModal";
import InquiryStageModal from "../../utils/InquiryStageModal";
import SettledModal from "../../utils/SettledModal";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";
const LeadStage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: LeadId } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [branchData, setBranchData] = useState([]);
  const [stageData, setStageData] = useState([]);
  const [applicationId, setApplicationId] = useState("");
  const [inquiryStage, setInquiryStage] = useState("");
  const [permission, setPermission] = useState(null);
  const [inquiryStageData, setInquiryStageData] = useState([]);
  const [selectedInquiryId, setSelectedInquiryId] = useState(null);
  const [showInquiryStageModal, setShowInquiryStageModal] = useState(false);
  const [isConverted, setIsConverted] = useState(false);
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [followUpDate, setFollowUpDate] = useState(null);


  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) {
      navigate("/");
    }
  }, []);

  const handleConfirm = async () => {
    const formData = new FormData();
    formData.append("loan_inquiry_id", selectedInquiryId);
    formData.append("follow_up_date", followUpDate);
    formData.append("created_by", userId);

    try {
      const response = await fetchFormData("loan-follow-up", formData, "POST");

      if (response?.code === 201) {
        topTost({
          title: "Follow-up added successfully",
          icon: "success",
        });
        setShowFollowUpModal(false);
        setSelectedInquiryId(null);
        fetchInitialData();
      }
    } catch (error) {
      console.error("Error submitting follow-up date:", error);
    }
  };
  const fetchInitialData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      // Show loading
      Swal.fire({
        title: "Loading ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const [branchResult, stageResult] = await Promise.all([
        fetchFormData("list-loan-inquiries", formData, "POST"),
        fetchData("loan-inquiry-statusesDrop", formData, "POST"),
      ]);

      if (branchResult) {
        setBranchData(branchResult.users || []);
      }

      if (stageResult) {
        setInquiryStageData(
          getValueLabel(stageResult.states, "loan_inquiry_status", "id") || []
        );
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
      Swal.fire("Error", "Failed to load data", "error");
    } finally {
      Swal.close(); // Hide loader
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("employee_id", userId);
    formData.append("status", LeadId);
    const result = await fetchFormData(
      "loan-inquiries-by-employee-status",
      formData,
      "POST"
    );

    if (result?.data) {
      setStageData(result.data);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [


    {
      accessorKey: "actions",
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.id;

        return (
          <div className="hstack gap-2 justify-content-end">

            <span
              className="cursor-pointer"
              onClick={() => {
                setSelectedInquiryId(id);
                setShowFollowUpModal(true);
              }}
              title="Follow Up"
            >
              <FiRefreshCcw size={16} />
            </span>


            <span
              className="cursor-pointer"
              onClick={() => {
                setSelectedInquiryId(id);
                setShowInquiryStageModal(true);
              }}
              title="Inquiry Stage"
            >
              <FiSliders size={16} />
            </span>

          </div>
        );
      },
      meta: {
        headerClassName: "width-30",
        exportable: false,
      },
    },

    {
      accessorKey: "lead_priority",
      header: "Inquiry Priority",
      cell: (info) => {
        const rawVal = String(info.getValue());
        const priority = leadPriorityData.find((item) => item.value === rawVal);
        if (!priority) {
          return (
            <span className="badge bg-soft-secondary text-secondary"></span>
          );
        }
        const colorMap = {
          "#E53935": "danger", // Red - Very High
          "#FB8C00": "warning", // Orange - High
          "#43A047": "success", // Green - Medium
          "#1E88E5": "primary", // Blue - Low
          "#8E24AA": "purple", // Purple - Info-like
          "#FDD835": "yellow", // Yellow - Moderate
          "#6D4C41": "brown", // Brown - Special
          "#00ACC1": "cyan", // Cyan - Info
          "#F06292": "pink", // Pink - Misc
          "#757575": "secondary",
        };

        const bootstrapColor = colorMap[priority.color] || "secondary";

        return (
          <span
            className={`badge bg-soft-${bootstrapColor} text-${bootstrapColor}`}
          >
            {priority.label}
          </span>
        );
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_inquiry_status",
      header: "Lead Status",
      cell: (info) => {
        const status = info.getValue();
        return (
          <span
            style={{
              backgroundColor: "#e3f2fd", // light blue
              color: "#0d6efd", // blue text
              padding: "4px 8px",
              borderRadius: "0.25rem",
              fontSize: "11px",
              display: "inline-block",
            }}
          >
            {status}
          </span>
        );
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "customer_name",
      header: "Customer Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_type_name",
      header: "Type",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "loan_amount",
      header: "Amount",
      defaultIsVisible: true,
      cell: (info) =>
        Number(info.getValue()).toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      accessorKey: "phone_number",
      header: "Phone Number",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "lead_source_name",
      header: "Lead Source",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "inquiry_date",
      header: "Inquiry Date",
      cell: (info) => new Date(info.getValue()).toLocaleDateString("en-GB"),
      defaultIsVisible: true,
    },
    {
      accessorKey: "Inquiries_Id",
      header: "Inquiry id",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "alternate_number",
      header: "Alternate Number",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "address",
      header: "Address",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "state_name",
      header: "State",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "district_name",
      header: "district",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "city_name",
      header: "City",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "refrence_name",
      header: "Reference Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "refrence_mobile",
      header: "Reference Mobile",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "follow_up_date",
      header: "Follow-up Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },

    {
      accessorKey: "remarks",
      header: "Remarks",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "assigned_user",
      header: "Assigned To",
      cell: (info) => info.getValue(),
      defaultIsVisible: true, // You might want to map ID to name
    },
    {
      accessorKey: "is_converted",
      header: "Converted",
      cell: (info) => (info.getValue() === 1 ? "Yes" : "No"),
    },
    {
      accessorKey: "converted_date",
      header: "Converted Date",
      cell: (info) =>
        info.getValue()
          ? new Date(info.getValue()).toLocaleDateString("en-GB")
          : "—",
    },
    {
      accessorKey: "created_by",
      header: "Created By",
      cell: (info) => info.getValue(), // map if needed
    },
  ];

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader />
          <div className="main-content">
            <div className="row">
              <div className="col-12">
                <Table data={stageData} columns={columns} />
              </div>
            </div>
          </div>
        </div>
      </main>
      <FollowUpModal
        show={showFollowUpModal}
        onClose={() => setShowFollowUpModal(false)}
        onConfirm={handleConfirm}
        followUpDate={followUpDate}
        setFollowUpDate={setFollowUpDate}
      />
      <InquiryStageModal
        show={showInquiryStageModal}
        onClose={() => setShowInquiryStageModal(false)}
        isConverted={isConverted}
        setIsConverted={setIsConverted}
        inquiryStage={inquiryStage}
        inquiryStageData={inquiryStageData}
        setInquiryStage={setInquiryStage}
        applicationId={applicationId}
        selectedInquiryId={selectedInquiryId}
        setApplicationId={setApplicationId}
        onConfirm={() => {
          setShowInquiryStageModal(false);
        }}
      />
    </>
  );
};

export default LeadStage;
